module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "edit-developer-roles-and-skills"
    }
  }, [_c('div', {
    staticClass: "edit-container roles-and-skills"
  }, [_c('label', [_vm._v("Developer Role")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.role),
      expression: "formData.role"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Developer Roles (e.x: Pixel Artist, Engine Programmer, 3D Modeler...)"
    },
    domProps: {
      "value": (_vm.formData.role)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.role = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "developer-roles"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.isProducer),
      expression: "formData.isProducer"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.isProducer) ? _vm._i(_vm.formData.isProducer, null) > -1 : (_vm.formData.isProducer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.isProducer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.isProducer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.isProducer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.isProducer = $$c
        }
      }
    }
  }), _vm._v("Producer")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.isDesigner),
      expression: "formData.isDesigner"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.isDesigner) ? _vm._i(_vm.formData.isDesigner, null) > -1 : (_vm.formData.isDesigner)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.isDesigner,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.isDesigner = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.isDesigner = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.isDesigner = $$c
        }
      }
    }
  }), _vm._v("Designer")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.isArtist),
      expression: "formData.isArtist"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.isArtist) ? _vm._i(_vm.formData.isArtist, null) > -1 : (_vm.formData.isArtist)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.isArtist,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.isArtist = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.isArtist = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.isArtist = $$c
        }
      }
    }
  }), _vm._v("Artist")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.isProgrammer),
      expression: "formData.isProgrammer"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.isProgrammer) ? _vm._i(_vm.formData.isProgrammer, null) > -1 : (_vm.formData.isProgrammer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.isProgrammer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.isProgrammer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.isProgrammer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.isProgrammer = $$c
        }
      }
    }
  }), _vm._v("Programmer")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.isWriter),
      expression: "formData.isWriter"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.isWriter) ? _vm._i(_vm.formData.isWriter, null) > -1 : (_vm.formData.isWriter)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.isWriter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.isWriter = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.isWriter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.isWriter = $$c
        }
      }
    }
  }), _vm._v("Writer")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.isMusician),
      expression: "formData.isMusician"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.isMusician) ? _vm._i(_vm.formData.isMusician, null) > -1 : (_vm.formData.isMusician)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.isMusician,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.isMusician = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.isMusician = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.isMusician = $$c
        }
      }
    }
  }), _vm._v("Musician")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.isSfxArtist),
      expression: "formData.isSfxArtist"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.isSfxArtist) ? _vm._i(_vm.formData.isSfxArtist, null) > -1 : (_vm.formData.isSfxArtist)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.isSfxArtist,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.isSfxArtist = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.isSfxArtist = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.isSfxArtist = $$c
        }
      }
    }
  }), _vm._v("SFX Artist")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.isTester),
      expression: "formData.isTester"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.isTester) ? _vm._i(_vm.formData.isTester, null) > -1 : (_vm.formData.isTester)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.formData.isTester,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.isTester = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.formData.isTester = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.formData.isTester = $$c
        }
      }
    }
  }), _vm._v("Tester")])]), _vm._v(" "), _c('label', [_vm._v("Skills")]), _vm._v(" "), _c('div', {
    staticClass: "existing-skill-list"
  }, [_vm._l((_vm.formData.skills), function(skillId) {
    return (_vm.formData.skills && _vm.formData.skills.length > 0) ? _c('span', {
      staticClass: "matching-skill-tag",
      on: {
        "click": function($event) {
          _vm.removeSkill(skillId)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-minus-circle"
    }), _vm._v("  " + _vm._s(_vm.skillList[skillId].skill) + "\n            ")]) : _vm._e()
  }), _vm._v(" "), (_vm.formData.skills && _vm.formData.skills.length === 0) ? _c('span', [_vm._v("No skills entered")]) : _vm._e()], 2), _vm._v(" "), _c('label', [_vm._v("Add Skill")]), _vm._v(" "), _c('div', {
    staticClass: "add-skill-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enteredSkill),
      expression: "enteredSkill"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search for Skill Tags..."
    },
    domProps: {
      "value": (_vm.enteredSkill)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enteredSkill = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.enteredSkill.length > 0) ? _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.enteredSkill = ''
      }
    }
  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "matching-skill-list"
  }, [(_vm.matchingSkills.length === 0) ? _c('span', [_vm._v("No matching tags... Search by skill name, or type a category to see all entries.")]) : _vm._e(), _vm._v(" "), (_vm.matchingSkills.length === 0) ? _c('span', [_vm._v("Categories: Art, Software, Development, Engine, Writing, Production, Testing")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.matchingSkills), function(skill) {
    return _c('span', {
      staticClass: "matching-skill-tag",
      on: {
        "click": function($event) {
          _vm.addSkill(skill.id)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-plus-circle"
    }), _vm._v(" " + _vm._s(skill.skill) + "\n            ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitChanges($event)
      }
    }
  }, [_vm._v("Save")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59940666!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Developer/Widgets/EditDeveloperRolesAndSkills.vue
// module id = 874
// module chunks = 2